module.exports = __webpack_public_path__ + "89e3f62931aaf3037ee684bad2f2c44e.svg";